import React from 'react';

const colorMap = {
  primary: 'bg-gradient-to-r from-blue-600 to-teal-600 text-white',
  secondary: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200',
  outline: 'border border-blue-500 text-blue-600 bg-white dark:bg-gray-900',
};

const ActionButton = ({ children, icon: Icon, onClick, color = 'primary', variant = 'primary', className = '', disabled = false, ...props }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={`flex items-center justify-center gap-2 px-3 py-1.5 rounded-lg font-semibold text-sm shadow transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed ${colorMap[variant] || colorMap.primary} ${className}`}
    {...props}
  >
    {Icon && <Icon className='w-4 h-4' />}
    {children}
  </button>
);

export default ActionButton; 